import * as React from "react";
import { AnchoredPanel, AnchoredPanelProps } from "../Panel/AnchoredPanel";
import { Listing, ListingProps } from "./Listing";

export interface ListingPanelProps<T> extends ListingProps<T>,
  Pick <AnchoredPanelProps, "anchorId" | "componentRef" | "title" | "subTitle" | "icon" | "onClose" | "isOpen" > {}

/**
 * A container anchored panel for the listing component
 */

// eslint-disable-next-line react/function-component-definition
export function ListingPanel<T>({
  itemKey,
  listColumns,
  items,
  itemsPerPage,
  selectionMode,
  selectedItems,
  actionBarItems,
  emptyList,
  sorting,
  isLoading,
  groupingSelect,
  viewSelect,
  filtering,
  listingComponentRef,
  minWidth,
  anchorId,
  componentRef,
  title,
  subTitle,
  icon,
  onClose,
  isOpen,
}: ListingPanelProps <T>): JSX.Element {
  return (
    <AnchoredPanel
      anchorId={anchorId}
      componentRef={componentRef}
      title={title}
      subTitle={subTitle}
      icon={icon}
      onClose={onClose}
      isOpen={isOpen}
    >
      <Listing
        itemKey={itemKey}
        listColumns={listColumns}
        items={items}
        itemsPerPage={itemsPerPage}
        selectionMode={selectionMode}
        selectedItems={selectedItems}
        actionBarItems={actionBarItems}
        emptyList={emptyList}
        sorting={sorting}
        isLoading={isLoading}
        groupingSelect={groupingSelect}
        viewSelect={viewSelect}
        filtering={filtering}
        listingComponentRef={listingComponentRef}
        minWidth={minWidth}
      />
    </AnchoredPanel>
  );
}
